<div class="card shadow">
    <div class="card-body">
        <div class="form-group">
            <input type="text" [formControl]="findControl" class="form-control" placeholder="digite usuario github" ref-texto/>
            <br>
            <button type="button" class="btn btn-info btn-block" (click)="finRepository(texto.value)">Buscar</button>
        </div>
    </div>
</div>